import { getAssetPath } from "@commonUtils"

export const parseWidgetData = (widgets) => {
    let widgetData = {}

    widgets.forEach((widget) => {
        switch (widget.type) {
            case "prescription_upload": {
                widgetData["removePrescriptionDialog"] = {
                    header: widget?.data?.cart_not_empty_dialog?.header,
                    subHeader: widget?.data?.cart_not_empty_dialog?.description,
                    icon: widget?.data?.cart_not_empty_dialog?.icon,
                    primaryCta: {
                        text: widget?.data?.cart_not_empty_dialog?.confirm_cta?.text,
                        functionMap: "removePrescription",
                    },
                    secondaryCta: {
                        text: widget?.data?.cart_not_empty_dialog?.cancel_cta?.text,
                        functionMap: "closeDialog",
                    },
                }
                widgetData["uploadPrescription"] = {
                    header: widget.data?.header,
                    headerIcon: getAssetPath("svgs/icons/help_18px_primary.svg"),
                    headerIconFunctionMap: "headerIconClick",
                    subHeader: widget.data?.view_items_cta ? `<u>${widget.data?.view_items_cta}</u>` : null,
                    subHeaderFunctionMap: "subHeaderClick",
                    uploadIcon: widget.data?.icon,
                    beforeUploadingCta: widget.data?.before_uploading_cta?.text,
                    afterUploadingCta: widget.data?.after_uploading_cta?.text,
                    handleUploadFunctionMap: "handleUpload",
                }
                break
            }
            case "low_emphasis_upsell": {
                widgetData["lowEmphasisUpsell"] = {
                    header: widget.data?.header,
                    description: widget.data?.display_text,
                    subHeader: widget.data?.sub_header,
                    time: widget.data?.time,
                    image: widget.data?.image_url,
                    actionLabel: widget.data?.cta?.text,
                    targetUrl: widget.data?.cta.target_url,
                    redirectUrl: widget.data?.redirection?.header,
                }
                break
            }
            case "footnotes": {
                widgetData["footnotes"] = {
                    subHeader: widget.data?.sub_text,
                    data: [
                        {
                            header: "",
                            displayText: `<u>${widget.data?.sub_text_cta || ""}</u>`,
                        },
                    ],
                }
                break
            }
            case "attentive_info": {
                widgetData["attentiveInfo"] = {
                    header: widget.data?.header,
                    subHeader: widget.data?.sub_header,
                    bgColor: widget.data?.bg_color,
                    targetUrl: widget.data?.url,
                }
                break
            }
        }
    })
    return widgetData
}

export const parseListCartItems = (data) => {
    // let widgets = data?.data?.widgets
    let pageInfoWidget = {}
    if (data?.action_button) {
        pageInfoWidget["actionButton"] = {
            action: data?.action_button?.action,
            targetUrl: data?.action_button?.target_url,
            text: data?.action_button?.text,
        }
    }
    if (data?.list_cart_items) {
        pageInfoWidget["listCartItems"] = {
            header: data?.list_cart_items?.header,
            groupItems: data?.list_cart_items?.grouped_items?.map((listOfItems) => {
                return {
                    itemInCart: listOfItems?.items.map((item) => {
                        return {
                            imageUrl: item?.icon,
                            header: item?.header,
                            subHeader: item?.sub_header,
                            skuId: item?.id,
                        }
                    }),
                }
            }),
        }
    }
    if (data?.how_it_works) {
        let howItWorks = data?.how_it_works
        pageInfoWidget["howItWorks"] = {
            header: howItWorks?.header,
            steps: howItWorks?.values.map((value) => {
                return {
                    header: value.header,
                    imageUrl: value.icon,
                    subHeader: value.sub_header,
                }
            }),
            ctaText: howItWorks?.cta?.text,
        }
    }
    if (data?.prescription_validation_guide) {
        pageInfoWidget["validPrescriptionMarkers"] = {
            ctaLabel: data?.prescription_validation_guide?.cta?.text,
            header: data?.prescription_validation_guide?.header,
            details: data?.prescription_validation_guide?.values.map((value) => {
                return {
                    header: value.header,
                    imageUrl: value.icon,
                    subHeader: value.text,
                }
            }),
        }
    }
    if (data?.rx_match_items) {
        let rxMatchItems = data?.rx_match_items
        let gaDataAutoAttachRx = {}
        pageInfoWidget["matchedPrescription"] = {
            header: rxMatchItems.header,
            values: rxMatchItems.values.map((value) => {
                return {
                    prescription: value?.prescription,
                    displayText: value?.display_text,
                    skus: value?.skus?.map((sku) => {
                        gaDataAutoAttachRx[sku?.id] = value?.id
                        return {
                            icon: sku?.icon,
                            displayText: sku?.display_text,
                            id: sku?.id,
                        }
                    }),
                }
            }),
        }
        pageInfoWidget["gaDataAutoAttachRx"] = gaDataAutoAttachRx
    }
    if (data?.ga_data) {
        pageInfoWidget["gaData"] = {
            items: data?.ga_data?.items,
            verifiedRx: data?.ga_data?.verified_rx,
            cd70: data?.ga_data?.screen_ga?.cd70,
        }
    }
    if (data?.why_rx_needed) {
        let rxData = data?.why_rx_needed
        if (rxData?.dont_have_prescription) {
            pageInfoWidget["dontHavePrescription"] = {
                header: rxData?.dont_have_prescription?.header,
                steps: rxData?.dont_have_prescription?.values.map((value) => {
                    return {
                        header: value.header,
                        imageUrl: value.icon,
                        subHeader: value.display_text,
                    }
                }),
            }
        }
        if (rxData?.prescription_required) {
            pageInfoWidget["prescriptionRequiredInfo"] = {
                dialogHeader: rxData?.header,
                steps: rxData?.prescription_required?.values.map((value) => {
                    return {
                        header: value.header,
                        imageUrl: value.icon,
                        subHeader: value.display_text,
                    }
                }),
            }
        }
    }
    if (data?.attached_prescriptions) {
        pageInfoWidget["attachedPrescription"] = {
            listOfImages: data.attached_prescriptions?.map((item) => {
                return {
                    image: {
                        url: item.transformed_urls.small,
                        xxhighUrl: item.file_attr?.length ? item.file_attr[0].file_url : "",
                        alt: "prescription",
                        id: item.id,
                        type:
                            item.file_attr[0]?.format?.includes("pdf") ||
                            item.file_attr[0]?.format?.includes("application")
                                ? "pdf"
                                : "image",
                        cta: {
                            functionMap: "prescriptionClicked",
                        },
                        statusText: item.status_text,
                        statusIcon: item.status_icon,
                        statusDescription: item.status_description,
                        documentUrl:
                            item.file_attr[0]?.format?.includes("pdf") ||
                            item.file_attr[0]?.format?.includes("application")
                                ? item.file_attr[0].file_url
                                : item.file_attr[0].file_url ||
                                  item.prescription_icon_url ||
                                  item.transformed_urls.xhigh,
                    },
                    iconOnImage: {
                        url: item.remove_cta?.icon,
                        alt: "remove prescription",
                        cta: {
                            functionMap: "removeIconClick",
                        },
                    },
                }
            }),
        }
    }
    return pageInfoWidget
}

/**
 * returning already attached prescription Images for your Prescriptions Page
 * @param {object} gallery
 * @return {object} for ImageGallery Widget to show already selected images
 */
const getSelectedImageIdObject = (gallery) => {
    let imagesObject = {}
    if (gallery?.length) {
        gallery.forEach((item) => {
            item.images?.forEach((image) => {
                if (image.selected) {
                    imagesObject[image.id] = image
                }
            })
        })
    }
    return imagesObject
}
/**
 * Creating parsed data for widgets for which this function is called
 * @param {object} data
 * @return {object} for ImageGallery Widget
 */
export const parseYourPrescriptions = (
    data,
    pageMeta,
    currentPageNumber = 0,
    existingPrescriptions = [],
    existingSelectedImages = []
) => {
    let hasMore = false
    let yourPrescriptions = {
        galleries: data.prescriptions?.gallery?.map((item) => {
            return {
                subText: item.header,
                images: item.images.map((image) => {
                    return {
                        src:
                            image?.type?.includes("application") || image?.type?.includes("pdf")
                                ? image.icon
                                : image.url,
                        id: image.id,
                        documentUrl: image.url,
                        selected: image.selected,
                        statusText: image.status_text,
                        type:
                            image?.type?.includes("application") || image?.type?.includes("pdf")
                                ? "pdf"
                                : "image",
                        header: { text: image.status_text, icon: image.status_icon },
                        description: image.status_description,
                        statusIcon: image.status_icon || "",
                    }
                }),
            }
        }),
        selectedImageIdObject: getSelectedImageIdObject(data.prescriptions?.gallery),
        stickyBottomButtonCtaLabel: data.cta?.text,
        rxAttachLimitData: data.rx_attach_limit_data,
    }
    if (pageMeta.total_pages > currentPageNumber + 1) {
        hasMore = true
    }
    let updatedExistingGallery
    if (currentPageNumber > 0) {
        let galleries = yourPrescriptions.galleries
        let tempExistingPrescriptions = existingPrescriptions
        let length = tempExistingPrescriptions.length
        if (tempExistingPrescriptions[length - 1].subText === galleries[0].subText) {
            galleries[0].images = tempExistingPrescriptions[length - 1].images.concat(galleries[0].images)
            updatedExistingGallery = tempExistingPrescriptions.slice(0, -1)
        } else {
            updatedExistingGallery = tempExistingPrescriptions
        }
        let combinedGalleries = updatedExistingGallery.concat(galleries)
        yourPrescriptions.galleries = combinedGalleries
        let selectedImageIdObject = yourPrescriptions.selectedImageIdObject
        let combinedSelectedImageIdObject = { ...existingSelectedImages, ...selectedImageIdObject }
        yourPrescriptions.selectedImageIdObject = combinedSelectedImageIdObject
    }
    return { yourPrescriptions: yourPrescriptions, currentPageNumber: currentPageNumber, hasMore: hasMore }
}

export const parseUploadLimit = (data) => {
    return {
        message: data?.message,
        limit: data?.attachment_limit,
        totalLimit: data?.total_limit,
    }
}
